
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import BorderBox from "@src/components/BorderBox";
import ListBox from "@src/components/ListBox";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuCrisscrossCrisssrossTopImage } from "@src/constants/images";
import { meta as pancakePageMeta } from "./pancake.mdx";
export const meta = {
  path: "/media/harajuku/crisscross",
  title: "【テイクアウトあり】表参道のクリスクロスのパンケーキメニュー、値段、支払い方法をご紹介！",
  description: "原宿・表参道のパンケーキの人気店である、クリスクロスのパンケーキメニューについて紹介させていただきます。クオリティーの高いパンケーキのテイクアウトができたり、支払い方法や値段など、あまり検索しても出てこないようなことまで幅広く調べて公開しております！原宿・「表参道でパンケーキを食べたい方は、クリスクロスへお越しください！",
  topImg: harajukuCrisscrossCrisssrossTopImage,
  author: murakamiMasanori,
  tags: ["表参道", "有名店", "おしゃれな内装", "スイーツ", "人気店", "お店の紹介", "パンケーキ", "インスタ映え"]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Text = makeShortcode("Text");
const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道のパンケーキの人気店である、クリスクロスのパンケーキメニューについて紹介させていただきます。`}</p>
    <p>{`クリスクロスでは、、クオリティーの高いパンケーキの`}<strong parentName="p">{`テイクアウト`}</strong>{`ができるお店として有名なので、テイクアウトのメニューを写真付きでご紹介します。`}</p>
    <p>{`また、トッピングしたパンケーキのイメージや、支払い方法や値段など、あまり検索しても出てこないようなことまで幅広く調べて公開しております！原宿・「表参道でパンケーキを食べたい方は、クリスクロスへお越しください！`}</p>
    <hr></hr>
    <h2>{`クリスクロスとは`}</h2>
    <p>{`原宿・表参道でモーニングメニューが美味しいとして有名なお店がクリスクロス 。`}</p>
    <p>{`開放感のある自然に囲まれたテラス席や、暗く照明がオレンジ色落とされた落ち着きのある店内が人気の理由になっています`}</p>
    <p>{`原宿・表参道の都会的な雰囲気とは異なり、落ち着いた大人な印象を受けみます。`}</p>
    <InstaImage postId="B5MhJ0CpO0t" mdxType="InstaImage" />
    <h2>{`パンケーキメニュー`}</h2>
    <p><strong parentName="p">{`ふわふわ`}</strong>{`のパンケーキというよりは、`}<strong parentName="p">{`もちもち`}</strong>{`のしっかりしたパンケーキがクリスクロスのパンケーキになります。
原宿・表参道エリアでは、ふわふわパンケーキが主流ですが、クラシックなパンケーキが食べられるお店がクリスクロス 。
今回は全てのパンケーキメニューをご紹介させていただきます！`}</p>
    <h3>{`クラシックバターミルクパンケーキ(税込：1,100 円)`}</h3>
    <InstaImage postId="B--w2QTAba5" mdxType="InstaImage" />
    <p>{`バターがたっぷり中央に乗ったベーシックなパンケーキになります。
三枚というボリューム感もしっかりあるメニューなので、オススメです！`}</p>
    <h3>{`バターミルクパンケーキ　ソーセージ、フライドエッグ (税込：1,400 円)(昼は 1,700 円になる)`}</h3>
    <InstaImage postId="B_4d7DvHw4P" mdxType="InstaImage" />
    <p>{`クリスクロスの 1 番の人気メニューで、インスタにもたくさん写真が上がっているメニューです！
こちらに乗っているソーセージはなんと`}<strong parentName="p">{`自家製`}</strong>{`だそう。
甘いパンケーキと塩気のあるソーセージとフライドエッグは相性抜群で、モーニングメニューでよく注文される方が多いそうです…！`}</p>
    <h3>{`マカダミアナッツのバターミルクパンケーキ　バニラソース、ホイップクリーム (税込：1,400 円)`}</h3>
    <InstaImage postId="B9ZF0MtH8gK" mdxType="InstaImage" />
    <p>{`クラシックパンケーキに、たっぷりとマカダミアナッツとソースがかかったハワイパンケーキ！
甘党の方にはオススメの一品。`}</p>
    <h3>{`期間限定スペシャルパンケーキ`}</h3>
    <p>{`期間限定で月替りのパンケーキが食べられるのもクリスクロスの魅力。`}</p>
    <h4>{`苺パンケーキ (税込：1,700 円)`}</h4>
    <InstaImage postId="B_YiK5IA3Ba" mdxType="InstaImage" />
    <p>{`2020 年 4 月末日まで販売されていたパンケーキになります！`}</p>
    <h4>{`オレンジとチョコナッツクリームのパンケーキ (税込：1,700 円)`}</h4>
    <InstaImage postId="B_1sGGapamo" mdxType="InstaImage" />
    <p>{`2020 年 5 月末日まで販売されているパンケーキになります！`}</p>
    <hr></hr>
    <h2>{`パンケーキトッピング`}</h2>
    <p>{`クリスクロス では、パンケーキに以下のトッピングできるようになっています！`}</p>
    <ListBox list={["フレッシュフルーツ(税込：400円)", "ホイップクリーム(税込：300円)", "アイスクリーム(税込：300円)", "自家製ジャム(税込：150円)"]} mdxType="ListBox" />
    <h3>{`クラシックバターミルクパンケーキ`}</h3>
    <InstaImage postId="B-jkEt9gBiC" mdxType="InstaImage" />
    <p>{`たっぷりとフルーツがかかったパンケーキで、フルーツの酸味と甘味がパンケーキとよく合う味になっています！`}</p>
    <h3>{`マカダミアナッツパンケーキ`}</h3>
    <InstaImage postId="B_PPa1gH3CS" mdxType="InstaImage" />
    <p>{`マカダミアナッツパンケーキにトッピングするとこのような感じに。
ボリューム感があるパンケーキですよね！`}</p>
    <h3>{`クラシックバターミルクパンケーキ`}</h3>
    <InstaImage postId="B804OTjAKU8" mdxType="InstaImage" />
    <p>{`中央に大きなアイスクリームがトッピングされています。
温かいパンケーキと冷たいアイスクリームが混ざり合う感じがたまらない一品です！`}</p>
    <hr></hr>
    <h2>{`テイクアウトメニュー`}</h2>
    <p>{`クリスクロスではテイクアウトも積極的に実施しています！
行列に並びたくなくて、待ち時間なくゆっくり家でパンケーキを食べたい方。
または、コロナなどで自粛期間の中、それでもパンケーキが食べたい方。
そんな方には、是非ご利用いただきたいテイクアウトになります！`}</p>
    <h3>{`パンケーキテイクアウトはこんな感じに！`}</h3>
    <InstaImage postId="B-9Od0PlUzd" mdxType="InstaImage" />
    <p>{`こちらは先ほど紹介したクラシックパンケーキになります！`}</p>
    <p><strong parentName="p">{`店内で頼むメニューがこちら`}</strong></p>
    <InstaImage postId="B9prQ9zHNl3" mdxType="InstaImage" />
    <p>{`ほとんどテイクアウトメニューと店内のメニューが変わらないクオリティー！
`}<strong parentName="p">{`マカダミアナッツパンケーキがテイクアウトできない`}</strong>{`ですが、それ以外の二つがでいくアウトできるようになっています。
店内で食べるのお t 同じクオリティーでテイクアウトができるようになっているので、ご自宅でもクリスクロスのパンケーキメニューを楽しんでいただければと思います！`}</p>
    <hr></hr>
    <h2>{`支払い方法`}</h2>
    <p>{`クリスクロス はクレジットカードが使えるようになっているので、キャッシュレスで普段現金を使わない方や、なるべく現金を使いたくない方には、支払いが楽だと思います。
クレカも幅広い種類のカード会社が使えるので安心です！`}</p>
    <BorderBox mdxType="BorderBox">
  <Text as="p" mdxType="Text">
    <Text as="span" fontWeight="bold" mdxType="Text">
      電子マネー：×
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      クレカ：○（VISA、Master、JCB、AMEX）
    </Text>
    <Text as="span" fontWeight="bold" mdxType="Text">
      現金：○
    </Text>
  </Text>
    </BorderBox>
    <hr></hr>
    <h2>{`アクセス`}</h2>
    <p>{`表参道できから`}<strong parentName="p">{`徒歩２分`}</strong>{`の好立地で、アクセス抜群！
原宿駅からも徒歩 10 分程度でアクセスできるので、山手線沿線を使う方もオススメになっています。`}</p>
    <GoogleMap lat={35.6629453} lng={139.7104083} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`クリスクロスのパンケーキについてご紹介させていただきましたが、いかがでしたか？
ご自宅でゆっくりパンケーキを楽しみたい方も、クオリティーの高い`}<strong parentName="p">{`テイクアウトメニュー`}</strong>{`で、クリスクロスのパンケーキが楽しめます！
ぜひ、原宿・表参道でパンケーキを楽しみたい方はクリスクロスへ！`}</p>
    <hr></hr>
    <p>{`また、他のパンケーキについてはこちらのページがオススメ！！`}</p>
    <LinkWithThumbnail meta={pancakePageMeta} mdxType="LinkWithThumbnail" />

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;